import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const YandexScaleSmallAppearanceDefault = hoc(
    (props: IconProps) => (
        <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g>
                <path
                    d="M8.00001 14.653C11.6744 14.653 14.6531 11.6743 14.6531 7.99995C14.6531 4.32555 11.6744 1.34686 8.00001 1.34686C4.32561 1.34686 1.34692 4.32555 1.34692 7.99995C1.34692 11.6743 4.32561 14.653 8.00001 14.653Z"
                    fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                />
                <path
                    d="M10.4073 12.1765H8.94684V4.95301H8.29622C7.10363 4.95301 6.47894 5.5493 6.47894 6.43943C6.47894 7.4493 6.9098 7.9172 7.80116 8.5135L8.53573 9.00856L6.42462 12.1752H4.85425L6.75425 9.34807C5.66166 8.56782 5.04684 7.80609 5.04684 6.52091C5.04684 4.91474 6.16659 3.82214 8.28635 3.82214H10.3975V12.174H10.4073V12.1765Z"
                    fill="white"
                />
            </g>
        </svg>
    ),
    'Yandex'
);
export default YandexScaleSmallAppearanceDefault;
